<template>
  <div class="chat-box">
    <avatar class="avatar" :imgSrc="serverAvatar" />
    <span class="text-message" v-html="item.content"></span>
  </div>
</template>

<script>
//询前页聊天消息item
export default {
  name: "before-page-chat-item",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      serverAvatar: state => state.serverAvatar
    })
  }
};
</script>

<style scoped lang="less">
.chat-box {
  margin-bottom: 5px;
  display: flex;
  .avatar {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .text-message {
    max-width: 80%;
    float: left;
    margin-bottom: 5px;
    display: inline-block;
    padding: 8px 10px;
    border-radius: 0 10px 10px 10px;
    font-size: 14px;
    color: #1e1e1e;
    line-height: 20px;
    background-color: var(--message-accept-bg) !important;
    /deep/ .yellow-text {
      color: var(--pre-button-help-click) !important;
    }
  }
}
</style>
